// src/routes/statistics/report/utils/chartColors.js

export const generateColor = (index, total) => {
    const hue = Math.floor((360 / total) * index);
    return `hsl(${hue}, 70%, 50%)`;
  };